import { render } from "./ProductPage.vue?vue&type=template&id=082a132d&scoped=true&ts=true"
import script from "./ProductPage.vue?vue&type=script&lang=ts"
export * from "./ProductPage.vue?vue&type=script&lang=ts"

import "./ProductPage.vue?vue&type=style&index=0&id=082a132d&scoped=true&lang=css"

import exportComponent from "/builds/moneyspace/moneyspace_homepage_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082a132d"]])

export default __exports__